var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLab = function SvgLab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.926 22.219a.5.5 0 0 0 0-1v1ZM16.56 9.805a.5.5 0 0 0 1 0h-1ZM8.926 21.22H3.42v1h5.507v-1Zm-7.007-1.5V3h-1v16.719h1ZM3.42 1.5h11.64v-1H3.419v1ZM16.56 3v6.805h1V3h-1Zm-1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h1a2.5 2.5 0 0 0-2.5-2.5v1ZM1.919 3a1.5 1.5 0 0 1 1.5-1.5v-1A2.5 2.5 0 0 0 .92 3h1Zm1.5 18.219a1.5 1.5 0 0 1-1.5-1.5h-1a2.5 2.5 0 0 0 2.5 2.5v-1Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.068 6.697h8.341M5.068 4.625h8.341M5.068 8.768h8.341M5.068 17.572h2.607",
    stroke: "#102B3F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.898 12.766-4.624-1.85c-.256-.099-.54-.099-.796 0l-4.624 1.85a1.067 1.067 0 0 0-.668.995v1.772a11.381 11.381 0 0 0 4.623 9.126c.306.222.675.342 1.053.341.388.007.767-.113 1.081-.341a11.38 11.38 0 0 0 4.638-9.155v-1.77a1.067 1.067 0 0 0-.683-.968Zm-.043 2.767a10.67 10.67 0 0 1-4.346 8.578 1.067 1.067 0 0 1-1.266 0 10.67 10.67 0 0 1-4.346-8.578v-1.771a.355.355 0 0 1 .22-.335l4.624-1.85a.355.355 0 0 1 .27 0l4.624 1.85a.355.355 0 0 1 .22.335v1.77Z",
    fill: "#102B3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.077 15.767h-1.779v-1.778a.356.356 0 0 0-.355-.356h-2.134a.356.356 0 0 0-.356.356v1.778h-1.778a.356.356 0 0 0-.356.355v2.134a.356.356 0 0 0 .356.356h1.778v1.778a.355.355 0 0 0 .356.356h2.134a.356.356 0 0 0 .356-.356v-1.778h1.778a.356.356 0 0 0 .355-.356v-2.134a.356.356 0 0 0-.355-.355ZM17.72 17.9h-1.778a.356.356 0 0 0-.356.355v1.779h-1.422v-1.779a.356.356 0 0 0-.356-.355H12.03v-1.423h1.778a.356.356 0 0 0 .356-.356v-1.778h1.422v1.778a.356.356 0 0 0 .356.356h1.778v1.423Z",
    fill: "#102B3F"
  })));
};

export default SvgLab;